/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SetSnsAccountErrorFromMkt24ReqBodyDto
 */
export interface SetSnsAccountErrorFromMkt24ReqBodyDto {
    /**
     * 이름
     * @type {string}
     * @memberof SetSnsAccountErrorFromMkt24ReqBodyDto
     */
    'name': SetSnsAccountErrorFromMkt24ReqBodyDtoNameEnum;
    /**
     * 플랫폼 이름
     * @type {string}
     * @memberof SetSnsAccountErrorFromMkt24ReqBodyDto
     */
    'platform': SetSnsAccountErrorFromMkt24ReqBodyDtoPlatformEnum;
}

export const SetSnsAccountErrorFromMkt24ReqBodyDtoNameEnum = {
    UserUnauthorized: 'user_unauthorized',
    UserChallengeRequired: 'user_challenge_required'
} as const;

export type SetSnsAccountErrorFromMkt24ReqBodyDtoNameEnum = typeof SetSnsAccountErrorFromMkt24ReqBodyDtoNameEnum[keyof typeof SetSnsAccountErrorFromMkt24ReqBodyDtoNameEnum];
export const SetSnsAccountErrorFromMkt24ReqBodyDtoPlatformEnum = {
    Instagram: 'instagram',
    Youtube: 'youtube',
    Facebook: 'facebook',
    Nblog: 'nblog',
    Googleplay: 'googleplay',
    Appstore: 'appstore',
    Kakaochannel: 'kakaochannel',
    Naverband: 'naverband',
    Web: 'web',
    Threads: 'threads'
} as const;

export type SetSnsAccountErrorFromMkt24ReqBodyDtoPlatformEnum = typeof SetSnsAccountErrorFromMkt24ReqBodyDtoPlatformEnum[keyof typeof SetSnsAccountErrorFromMkt24ReqBodyDtoPlatformEnum];


